export default {
  LIST_PAGE: {
    TITLE: `Rapport d'audit`,
    SUMMARY: ``
  },
  BY: `Par`,
  ACTION: `Action`,
  DATE: `Date`,
  ON_THE: 'le',
  ON: 'sur',
  TO: 'à',
  OF: 'de',
  FOR: 'pour',
  FROM: 'à',
  AND: 'et',
  AT: `à`,
  UPDATED: 'a mis à jour',
  UPDATED_BULLETIN: `a mis à jour l'annonce`,
  CREATED_BULLETIN: 'a créé une nouvelle annonce :',
  DELETED_BULLETIN: `a supprimé l'annonce`,
  TRIED_TO: 'a essayé de',
  CONNECT_TO: "se connecter à l'application",
  INVALID_USERNAME: "avec un nom d'utilisateur invalide",
  INVALID_PASSWORD: 'avec un mot de passe invalide',
  INVALID_TOKEN: 'avec un jeton invalide',
  INVALID_EMAIL: 'avec une adresse courriel invalide',
  ERROR_GENERATING_TEMPLATE: 'erreur de génération de courriel',
  USERNAME_RECOVERY_REQUESTED: "Récupération du nom d'utilisateur demandée",
  USERNAME_RECOVERY: "pour la récupération du nom d'utilisateur",
  USERNAME_EMAIL_NOT_FOUND: "avec un nom d'utilisateur ou une adresse courriel introuvable",
  EMAIL_NOT_FOUND: 'avec une adresse courriel introuvable',
  NO_TOKEN: 'sans jeton',
  SUCCESS: 'a réussi à',
  ATTEMPT_LIMIT: 'a atteint la limite',
  RENEWED_TOKEN: 'a renouvelé un jeton',
  ADDED: 'a ajouté',
  WAS_ADDED: 'a été ajouté',
  WAS_UPDATED: 'a été mis à jour',
  WAS_DELETED: 'a été supprimé',
  REMOVED: 'a enlevé',
  CONFIRMED: 'a accusé réception',
  MANUALLY_CONFIRMED: 'a accusé réception manuellement',
  NEW_DEPARTMENTS: 'de nouveaux départements',
  DEPARTMENTS: 'le département',
  AVAILABILITIES: 'des disponibilités',
  NEW_LEAVE: 'une nouvelle absence',
  LEAVE: 'une absence',
  APPROVED: 'a approuvé',
  REFUSED: 'a refusé',
  CANCELLED: 'a annulé',
  RESTORED: 'a rétabli',
  APPROVED_STATUS: 'a approuvé',
  REFUSED_STATUS: 'a refusé',
  CANCELLED_STATUS: 'a annulé',
  ACKNOWLEDGED_STATUS: 'Reçue',
  JUSTIFIED_STATUS: 'Justifiée',
  UNJUSTIFIED_STATUS: 'Non justifiée',
  PERMISSION: 'la permission',
  PERMISSIONS: 'des permissions',
  NEW_PERMISSION: 'une nouvelle permission',
  PROJECT: 'un projet',
  NEW_PROJECT: 'un nouveau projet',
  SHIFTS: 'quarts de travail',
  NEW_ATTRIBUTE_LEVEL: "un nouveau niveau d'attribut",
  ATTRIBUTE_LEVEL: 'un nouvel attribut',
  ATTRIBUTE: 'un attribut',
  STRUCTURE: 'une structure',
  STRUCTURE_ATTRIBUTE: "l'attribut de la structure ",
  HIRING_DATA: "des données d'embauche",
  VALIDATED_INFO: " a validé l'information",
  EMPLOYEE_ATTRIBUTE: `l'attribut de l'employé`,
  NEW_TIME_OFF: 'un nouveau congé',
  TIME_OFF: 'un congé',
  OVERTIME_LIST: 'une liste de comblements',
  ERROR: 'Erreur : ',
  CREATING_RANDOM_TOKEN: "création d'un jeton aléatoire",
  PASSWORD_RESET: 'pour la réinitialisation du mot de passe',
  FORCE_RESEND: 'a forcé le renvoi de la notifications des quarts de travail et congés',
  SENT_CONFIRMATIONS: 'a envoyé une ou des notifications(s) de quart de travail pour les dates',
  SENT_CANCELLATION_NOTICE: `a envoyé des avis d'annulation de quart pour `,
  CONFIRMATION_SHIFT_SENT: 'La notifications des quarts de travail et congés a été envoyée',
  NO_EMAIL: "n'a pas d'adresse courriel",
  SENDING_EMAIL: "d'envoi de courriel",
  EVENT: 'un événement',
  RESOURCE_NAME: 'nom de la ressource',
  IF_APPLICABLE: 'si applicable',
  RESOURCE_Id: 'Id ressource ',
  NEW_USERS: 'nouveaux utilisateurs',
  REGISTERED_DEVICE: 'a enregistré un appareil',
  PHONE_OF: 'Le téléphone de',
  LIST_PAUSED: 'liste est en pause',
  START: 'a commencé',
  FORCED_PAUSE: "a forcé la pause d'",
  ARCHIVED_LIST: "a archivé la liste d'heures supplémentaires",
  DELETED_LIST: "a supprimé la liste d'heures supplémentaires",
  CHANGED: 'a changé',
  LIST_STATUS: "le statut d'une liste",
  PERMITTED_LISTS: 'les listes permises',
  LIST_TYPE: "le type d'une liste",
  STATUS: 'le statut',
  TO_OFFER: 'à offrir',
  HISTORY: "l'historique",
  LOCKED_CALLS: 'a fermé les appels',
  NOTIFICATIONS: 'notifications',
  LIST: 'la liste',
  BIDS: 'des offres',
  NEW_EVENTS: 'nouveaux événements',
  IMPORTED: 'a importé',
  NEW_TEMPLATE: 'un nouveau gabarit',
  TEMPLATE: 'gabarit',
  APPLIED: 'a appliqué',
  ABSENCE: 'une absence',
  BY_TELEPHONE: 'par téléphone',
  LATE_REQUEST: 'une demande tardive',
  CHECKED_MESSAGES: 'a vérifié ses messages',
  USER: 'un utilisateur',
  NOT_WORKING: 'ne fonctionne pas',
  MINUTE: 'minutes',
  DELAY_BEFORE_NEXT_CALL: 'délai avant le prochain appel',
  DELAY_BETWEEN_CALLS: 'délai entre les appels',
  EXPIRED: 'est expiré',
  SHIFT_CONFIRMATION_EMAIL: 'courriel de notification de quart ou congé',
  GET_SETTINGS: 'obtenir les paramètres',
  GET_USER_INFORMATION: "obtenir l'information de l'utilisateur",
  NEW_CLIENT: 'un nouveau client',
  CLIENT: 'le client',
  INFORMATION: 'les informations',
  UNAPPROVED_SHIFT: "n'a pas approuvé les quarts de travail",
  APPROVED_SHIFT: 'a approuvé les quarts de travail',
  INDEX: 'index',
  CREATED: 'a créé',
  HIS_SETTING: 'ses paramètres',
  DELETED: 'a supprimé',
  REQUEST_FIELD: 'un champ de requête',
  SAVED: 'a sauvegardé',
  NEW_VACATION_DISTRIBUTION: 'une nouvelle distribution de vacances',
  APP_SETTING: "un paramètre d'application",
  IMPORT_CONFIG: "une configuration d'importation",
  UPLOADED: 'transféré',
  ATTRIBUTE_FILE: `fichier de l'attribut`,
  VACATION_DISTRIBUTION: 'une distribution de vacances',
  NEW_VACATION_DISTRIBUTION_CHOICE: 'un nouveau choix de distribution de vacances',
  FILTER_MODULE: '',
  NOTIFICATION: 'notification',
  CALLED_HOTLINE: "a appelé la ligne téléphonique de l'application",
  INVALID_EMPLOYEE_NUMBER: "avec un numéro d'employé invalide",
  LOGGED_IN: "s'est connecté",
  WITH_PIN: 'avec un NIP',
  RENEWE_TOKEN: 'a renouvelé un jeton',
  NEW_VACATION: 'une nouvelle vacance',
  UPDATED_A_BULLETIN: 'a mis à jour une nouvelle',
  ATTRIBUTE_URL: `lien de l'attribut`,
  EMPLOYEE_NUMBER_ONLY: "avec son numéro d'employé",
  VACATION_DISTRIBUTION_CHOICE: 'son choix de vacances',
  SHIFT_SWAP: 'un échange de quarts de travail',
  CANCEL_SHIFT_SENT: 'Annulation du quart de travail envoyée',
  EMAIL_BATCH_COMPLETED: 'Le lot de courriels envoyés',
  SUCCEEDED: 'Succès!',
  FAILED: 'Échec',
  TOTAL: 'Total',
  EVENTS: 'événement',
  MADE_NO_CHANGES: "n'a fait aucun changement",
  FAILED_TO_SEND_EMAIL_TO: "Erreur d'envoi à ",
  ARCHIVED: 'a archivé',
  UNARCHIVED: 'a désarchivé',
  PAUSED: 'a mis sur pause',
  STARTED: 'a lancé',
  MERGED: 'a fusionné',
  RESUMEED: 'a reparti',
  IN_PUNCH_TERMINAL: 'au terminal du poinçon',
  PUNCHED: 'a enregistré son temps',
  LAUNCHED: 'a lancé un ',
  PUNCH_TERMINAL: 'terminal du poinçon',
  PUNCH_CARD: 'une carte de temps',
  PUNCHED_IN: "a enregistré son heure d'entrée",
  PUNCHED_OUT: 'a enregistré son heure de sortie',
  NEW_TEAM: 'une nouvelle équipe',
  TEAM: "l'équipe",
  PHONE_NUMBERS: 'Numéro de téléphone',
  EMAILS: 'courriels',
  PICTURE: 'Image',
  PASSWORD_WAS_RESET: 'Mot de passe réinitialisé',
  PASSWORD_RESET_REQUESTED: 'Réinitialisation du mot de passe demandée',
  COMPANY_URL_REQUESTED: 'URL de la compagnie demandée',
  FILTER_BY_DATES: 'Filtrer les audits par date et heure',
  RECEIVED_SHIFT_CONFIRMATION_CALL: 'a reçu un appel de notification de quart de travail au',
  FOR_SHIFT_CONFIRMATION: 'pour la notification',
  RECEIVED_AN_EMAIL_TO: "a reçu un courriel à l'adresse",
  TO_CONFIRM_SHIFT: 'pour envoyer les notifications des quarts de travail',
  FOR_CANCELLED_SHIFT: 'pour les quart(s) de travail annulé(s)',
  NEED_USERNAME: "(nom d'utilisateur requis, plusieurs utilisateurs ont cette adresse courriel)",
  SAME_EMAIL_CONTACT_MANAGER: ", mais la vérification d'un gestionnaire est nécessaire (plusieurs comptes avec la même adresse courriel)",
  TEAMS: 'les équipes',
  REGION_TAGS: "l'étiquette de région",
  SCHEDULE_TYPE: `un type de quart`,
  POSITIONS: `une position`,
  PUNCH_RULES: `une règle de carte de temps`,
  WAGE_PREMIUM: `un code de prime`,
  CONTACT_TEMPLATE: `un modèle de contact (notification)`,
  MODULE: `Module`,
  modules: {
    attributeLevel: `Niveau d'attribut`,
    attributes: `Attribut`,
    authentication: `Authentification`,
    availability: `Disponibilité`,
    billing: `Billing`,
    bulletin: `Babillard`,
    clients: `Clients`,
    contactListConfigss: `Configuration des lists de contact`,
    contactLists: `Liste de contact`,
    contactTemplates: `Liste de contact (modèle de notification)`,
    departmentModification: `Modification aux départements`,
    departments: `Départements`,
    emails: `Courriel`,
    finalize: `Finalisation`,
    generateSchedule: `Génération d'horaire`,
    groupsPermission: `Groupe de permission`,
    hiringData: `Donnée d'embauche`,
    leave: `Absence`,
    pay: `Paie`,
    permissions: `Permissions`,
    projects: `Projets`,
    punch: `Poinçons`,
    punchRules: `Règles de carte de temps`,
    regionalTags: `Étiquettes de région`,
    requestsFields: `Type de requêtes`,
    resolve: `Résolution de problème d'horaire`,
    schedule: `Horaire`,
    scheduleConfirmation: `Confirmation de quart`,
    scheduleTemplate: `Modèle d'horaire`,
    scheduleTypes: `Type de quart`,
    settings: `paramètre`,
    'shift-cancellation-email': `Courriel de cancellation de quart`,
    'shift-confirmation-email': `Courriel de notification de quart`,
    'shift-confirmation-phone': `Appel de notification de quart`,
    structure: `Position`,
    structureAttributes: `Attribut de position`,
    tags: `Étiquettes`,
    teams: `Équipes`,
    twilio: `Système d'appel`,
    user: `Utilisateur`,
    userAttributes: `Modification aux attributs d'utilisateur`,
    userDepartments: `Modification aux départements d'utilisateur`,
    userEmails: `Modification aux adresses courriels d'utilisateur`,
    userFilters: `Filtre des listes de contact`,
    userHiringData: `Modification aux données d'embauche d'utilisateur`,
    userPermissions: `Modification aux permissions d'utilisateur`,
    userPhoneNumbers: `Modification aux numéro de téléphones d'utilisateur`,
    userPicture: `Modification aux photo d'utilisateur`,
    userPronouns: `Modification des pronoms de l'utilisateur`,
    userPositions: `Modification aux positions d'utilisateur`,
    userProcedures: `Modification aux procédure de liste de contact`,
    userRegionalTags: `Modification aux regions d'utilisateur`,
    userSorts: `Modification aux ordonnancements des listes de contact`,
    userTeams: `Modification aux équipes d'utilisateur`,
    users: `Utilisateurs`,
    vacation: `Congé`,
    vacationModule: `Congé`
  }
}
